import { ReactElement, useMemo } from 'react'
import * as S from '../Styled'

interface IBannerConfig {
  shouldRender: boolean
  banner: ReactElement
}

/**
 * 返回只包含一个固定 Banner 的配置
 * 统一使用 /images/banner.jpg 这一个 banner 图
 */
export const useMultipleBannerConfig = () => { 
  const banner: IBannerConfig = {
    shouldRender: true,
    banner: (
      <S.Wrapper
        style={{
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <img 
          src="/images/banner.jpg" 
          alt="Banner" 
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '32px',
          }}
        />
      </S.Wrapper>
    ),
  }
        
  return [banner.banner]
}
